import * as _ from 'lodash';
import { Pipe, PipeTransform } from '@angular/core';
import { SummaryI } from 'src/app/services/badge/summary';

@Pipe({
  name: "getbykey"
})
export class GetByKeyPipe implements PipeTransform {

  transform( summary: SummaryI, key: string ): number {
    return summary?.[key as keyof SummaryI]
  }
}
